import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"edit\"><title>edit</title><g id=\"edit__visibility\"><g id=\"edit_Layer_8-2\" data-name=\"Layer 8\"><path d=\"M15.13,1.42,3.3,13.26,1.88,18a.74.74,0,0,0,.7.95h.15l5.15-1L19.73,6ZM18.31,6l-1,1L14.09,3.88l1-1ZM4,14.35l2.73,2.73L3,17.84Zm3.69,2.28L4.53,13.44l8.86-8.86,3.18,3.18Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/edit.svg
// module id = TIm7
// module chunks = 4